import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import auth from '@/store/modules/auth'
import application from '@/store/modules/application'
import client from '@/store/modules/client'
import security from '@/store/modules/security'

Vue.use(Vuex)

const vuexSessionStorage = new VuexPersist({
  key: 'dp-auth',
  storage: window.sessionStorage,
  reducer: (state) => ({
    application: {
      ...state.application
    }
  })
})

const vuexLocalStorage = new VuexPersist({
  key: 'dp-auth',
  storage: window.localStorage,
  reducer: (state) => ({
    client: {
      ...state.client
    },
    auth: {
      ...state.auth
    }
  })
})

export default new Vuex.Store({
  plugins: [vuexSessionStorage.plugin, vuexLocalStorage.plugin],
  modules: {
    auth,
    application,
    client,
    security
  },
  state: {},
  mutations: {},
  actions: {},
  strict: true
})
